import script from "./vip.vue?vue&type=script&setup=true&lang=js"
export * from "./vip.vue?vue&type=script&setup=true&lang=js"

import "./vip.vue?vue&type=style&index=0&id=5580f4d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5580f4d1"]])

export default __exports__